import { render, staticRenderFns } from "./installerDetail.vue?vue&type=template&id=74a65703&"
import script from "./installerDetail.vue?vue&type=script&lang=js&"
export * from "./installerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports